import { render, staticRenderFns } from "./RoundedYoutubeIcon.vue?vue&type=template&id=12ca58b0"
import script from "./RoundedYoutubeIcon.vue?vue&type=script&lang=js"
export * from "./RoundedYoutubeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports